import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "292",
  "slug": "spot-iceland-from-satellite-imagery",
  "title": "How to Recognise Iceland in Satellite Images",
  "excerpt": "Iceland combines broad ice caps, sparsely vegetated interior terrain, and a deeply indented coastline in the northwest and east.",
  "date": "2026-04-29",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/iceland.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Iceland combines broad ice caps, sparsely vegetated interior terrain, and a deeply indented coastline in the northwest and east. In a regional overview, Vatnajökull is a large bright feature in the southeast. Snow cover elsewhere changes with the season, so distinguish a persistent ice cap from temporary snow."
    },
    {
      "type": "heading",
      "text": "Ice caps and an irregular coast"
    },
    {
      "type": "paragraph",
      "text": "Compare the Westfjords with the south coast. The contrast between branching inlets and the more continuous southern shoreline is visible at a wide scale."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Dark volcanic ground and ice can occur together in other high-latitude regions. A close crop of snow or lava does not identify an island. Check the wider coast and the relationship between ice and surrounding relief."
    }
  ],
  "imageAlt": "Iceland regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
